import React from 'react';
import axios from "../../containers/api";
import {showCatchError} from "../../helpers/Utils";
import { Button, Card, CardBody, ModalBody, Modal, ModalHeader, Row, Badge, ModalFooter } from "reactstrap";
import {Table} from "../../components/table/Table";
import {Colxx, Separator} from "../../components/common/CustomBootstrap";

import NewComment from "./NewComment";
 

class ManageComment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            CommentLists: [],
            errors: [], 
            EditModal: false,
            OneComment: {}, 
            CommentId: null, 
            optionsMenu: null, 
        }
        console.log(this.props)
    }

    componentDidMount() {
         
        // this.CheckMemberTypeIsAdmin();
        if (this.props.memberType.role === 'TransportationCompanyAdmin')
            this.GetAllTransportationCompanyComment();
        
        else if (this.props.memberType.role === 'Driver')
            this.GetAllDriverComment();
      
    }

    CheckMemberTypeIsAdmin = () => {
        this.props.showSpinner();
        axios.get('api/ClientApi/CheckMemberTypeIsAdmin')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data) {
                    if (this.props.memberType.role === 'TransportationCompanyAdmin')
                        this.GetAllTransportationCompanyComment();

                    else if (this.props.memberType.role === 'Driver')
                        this.GetAllDriverComment();
                } else {
                    this.props.history.push('/error404')
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };

    GetAllTransportationCompanyComment = () => {
        this.props.showSpinner();
        axios.get('api/v1/Comment/GetByTransportationCompanyId')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null) 
                        this.setState({CommentLists: res.data.data});
                else
                this.setState({ alertText: res.data.errors, loginAlert: true, loading: false });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
   
    GetAllDriverComment = () => {
        this.props.showSpinner();
        axios.get('api/v1/Comment/GetByDriverId')
            .then((res) => {
                this.props.hideSpinner();
                if (res.data.data !== null)
                    this.setState({ CommentLists: res.data.data });
                else
                    this.setState({ alertText: res.data.errors, loginAlert: true, loading: false });
            })
            .catch((error) => {
                this.props.hideSpinner();
                this.props.showAlert(showCatchError(error), "error");
                console.log(error.response);
            });
    };
    OptionsMenuClick = (event, id) => {
        this.setState({ [id]: event.currentTarget, optionsMenu: id });
    };
    OptionsMenuClose = (id) => {
        this.setState({ [id]: null, optionsMenu: null });
    };
    openModal = (modalName, item) => {
        
         
        this.setState({ [modalName]: true });
    }
    closeModal = (modalName) => {
        this.setState({ [modalName]: false });
        if (this.props.memberType.role === 'TransportationCompanyAdmin')
            this.GetAllTransportationCompanyComment();

        else if (this.props.memberType.role === 'Driver')
            this.GetAllDriverComment();
        
    }
     
    render() {
        return (
            <>
                <Row>
                    <Colxx xxs="12">
                        <h3>رسیدگی به شکایات</h3>
                        <Separator className="mb-5" />
                    </Colxx>
                </Row>

                <Row className="mb-3">
                    <Colxx xxs="12">
                        <Card>
                            <CardBody className="d-flex flex-column justify-content-center align-items-center">
                                <div className="d-flex justify-content-center w-100">
                                    <Button outline color="primary" className="mx-3"
                                            onClick={() => this.openModal("AddModal")}>
                                        افزودن پیام جدید
                                    </Button>
                                </div>

                                <Table
                                    tableHeaders={[
                                        "عنوان",
                                        "متن پبام",
                                        "تاريخ پبام",
                                        "ساعت پيام",
                                        "کد رهگیری",
                                    ]}

                                    tableRow={this.state.CommentLists}

                                    tableData={[
                                        item => {
                                            return item.title
                                        },
                                        item => {
                                            return item.desc
                                        },
                                        item => {
                                            return item.date;
                                        },
                                        item => {
                                            return item.time;
                                        },
                                        item => {
                                            return item.trackingCode;
                                        },
                                        
                                    ]}
                                />
                            </CardBody>
                        </Card>
                    </Colxx>
                </Row>

                <Modal isOpen={this.state.AddModal} size="xlg" toggle={() => this.closeModal("AddModal")}>
                    <ModalHeader toggle={() => this.closeModal("AddModal")}>
                        افزودن پیام جدید
                    </ModalHeader>
                    <ModalBody>
                        <NewComment
                            isModal={true}
                           // ProvinceList={this.state.ProvinceList}
                            showSpinner={this.props.showSpinner}
                            hideSpinner={this.props.hideSpinner}
                            showSweetAlert={this.props.showSweetAlert}
                            closeSweetAlert={this.props.closeSweetAlert}
                            showAlert={this.props.showAlert}
                        />
                    </ModalBody>
                </Modal> 
            </>
        );
    }
}

export default ManageComment;